import React from 'react';
import { Link } from 'react-router-dom';
import networkLogo from '../../assets/img/NetworkDirectoryButton_Long.png';
import { FormattedMessage } from 'react-intl';
import { getPublicUrl, getEnv } from '../../utilities/env';

/**
 * Footer component
 */

function Footer(props) {
  let showNetwork = true;
  if (props.showNetwork !== undefined) {
    showNetwork = props.showNetwork;
  }
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <footer aria-label="Footer Links" data-test="footer">
      <div className="footer-box footer-box__status-logo">
        <a
          href="http://www.statussolutions.com"
          target="_blank"
          rel="noopener noreferrer"
          data-test="footer-status-logo-link">
          <img
            src={`${getPublicUrl()}/Status_Solutions_Logo.svg`}
            alt="Status Solutions"
            className="footer-image"
            data-test="footer-status-logo"
          />
        </a>
      </div>
      <div className="footer-box footer-box__info-box text-small">
        <FormattedMessage
          data-test="footer-status-link"
          id="footer.homePageLink"
          defaultMessage="Status Solutions"
          description="Footer link to Status Solutions homepage">
          {(txt) => (
            <a
              href="http://www.statussolutions.com"
              target="_blank"
              rel="noopener noreferrer"
              data-test="footer-status-link-text">
              {txt}
            </a>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="footer.eula"
          data-test="footer-eula-link"
          defaultMessage="EULA"
          description="Footer link to the End User License Agreement (EULA)">
          {(txt) => (
            <Link data-test="footer-eula-link-text" to="/eulaView">
              {txt}
            </Link>
          )}
        </FormattedMessage>
        <FormattedMessage
          data-test="footer-privacy-link"
          id="footer.privacyPolicy"
          defaultMessage="Privacy Policy"
          description="Footer link to the privacy policy page">
          {(txt) => (
            <a
              data-test="footer-privacy-link-text"
              href="http://www.statussolutions.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer">
              {txt}
            </a>
          )}
        </FormattedMessage>
        {!showNetwork ? (
          <FormattedMessage
            id="footer.networkDirText"
            defaultMessage="The Network Directory"
            description="Footer link to the school solutons network directory"
            data-test="network-directory-link">
            {(txt) => (
              <a
                data-test="network-directory-link-text"
                href="https://www.statussolutionsnetwork.com/network-directory/"
                target="_blank"
                rel="noopener noreferrer">
                {txt}
              </a>
            )}
          </FormattedMessage>
        ) : (
          ''
        )}
        <FormattedMessage
          id="footer.contactUs"
          data-test="footer-contact-link"
          defaultMessage="Contact Us"
          description="Footer link to a page to contact Status Solutions">
          {(txt) => (
            <a
              data-test="footer-contact-link-text"
              href="http://www.statussolutions.com/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link">
              {txt}
            </a>
          )}
        </FormattedMessage>
      </div>

      <div className="footer-box footer-box__logo-box">
        {!showNetwork ? (
          ''
        ) : (
          <a
            href="https://www.statussolutionsnetwork.com/network-directory/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-image"
            data-test="network-directory-logo">
            <img
              className="footer-image"
              src={networkLogo}
              alt="The network directory logo"
            />
          </a>
        )}
      </div>
      <FormattedMessage
        id="footer.copyright"
        defaultMessage="© Copyright {br}. All Rights Reserved. Status Solutions, LLC."
        values={{
          br: currentYear,
        }}
        description="Footer copyright text">
        {(txt) => (
          <div
            className="footer-box footer-box__info-box text-small"
            id="footer-copyright">
            {txt}
          </div>
        )}
      </FormattedMessage>
      {getEnv('REL') && (
        <div className="footer-box footer-version" data-test="footer-version">
          {getEnv('REL')}
        </div>
      )}
    </footer>
  );
}

export default Footer;
